import { render, staticRenderFns } from "./MainInfoColumnRmsOko.vue?vue&type=template&id=777cc18a&scoped=true&"
import script from "./MainInfoColumnRmsOko.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumnRmsOko.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumnRmsOko.vue?vue&type=style&index=0&id=777cc18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777cc18a",
  null
  
)

export default component.exports